import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledWrapperContent = styled.div`
  padding: 4.6rem 4.6rem 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 2.4rem;

  h2 {
    margin-bottom: 0;
    font-size: 3.2rem;
  }

  p {
   font-size: ${({ theme }) => theme.fonts.sizes.medium};
  }
`;

export const StyledShareButton = styled(Button)`
  &:hover:not(:disabled) {
    color: white;
  }
  svg {
    fill: white;
  }
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const StyledActionButtonsWrapper = styled.div`
  display: flex;
  gap: 1.7rem;
`;

export const StyledActionButton = styled(Button)`
  padding: 0.85rem 0.9rem;
  background: ${({ theme }) => theme.colors.background.main};

  svg {
    width: 1.6rem;
    height: 1.9rem;
  }
`;
